
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/personbil",
      function () {
        return require("private-next-pages/tyres/personbil.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/personbil"])
      });
    }
  